import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import swal from 'sweetalert2';
import { UiService } from '../../../../../../../services/ui/ui.service';
import { AdminService } from '../../../../services/admin/admin.service';
import { EventService } from '../../../../../../../services/event/event.service';

@Component({
  selector: 'app-register-student-modal',
  templateUrl: './register-student-modal.component.html',
  styleUrls: ['./register-student-modal.component.css']
})
export class RegisterStudentModalComponent implements OnInit {

  @Input() type: 'student' | 'exchange' = 'student';
  @Input()
  set courseId(value) {
    this._courseId = value;
  }

  @Output() registered = new EventEmitter();

  private _courseId = null;

  private apis = {
    'student': '/user/register',
    'guest-student': '/guest-student/user'
  }

  public newStudent = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    phone: '',
    company_name: '',
    designation: '',
    country: '',
    city: '',
    img: '../assets/img/icon-no-image.png'
  };

  private imgFile = null;

  constructor(
    private ui: UiService,
    private adminService: AdminService,
    public event: EventService
  ) { }

  ngOnInit() {
  }

  showStudentRegisterModal() {
    this.newStudent = {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      phone: '',
      company_name: '',
      designation: '',
      country: '',
      city: '',
      img: '../assets/img/icon-no-image.png'
    };
    this.imgFile = null;
  }

  public showImg = true;
  uploadImage(event) {
    const e = event;
    if (event.target.files && event.target.files[0]) {
      this.imgFile = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (event: ProgressEvent) => {
        this.newStudent.img = (<FileReader>event.target).result;
        this.showImg = false;
        setTimeout(() => this.showImg = true, 0);
        e.target.value = '';
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  @ViewChild('studentRegisterModalCloseBtn') public studentRegisterModalCloseBtn: ElementRef;
  submitStudentRegisterForm() {
    if (!this.newStudent.first_name || !this.newStudent.last_name || !this.newStudent.email || !this.newStudent.password) {
      swal('Warning!', 'Name, Email & Password is required', 'warning');
      return;
    }
    const payload = { ...this.newStudent, course_id: this._courseId };
    if (!this.imgFile) {
      delete payload.img;
    } else {
      payload.img = this.imgFile;
    }
    this.ui.loader.show('register-student-list => submitStudentRegisterForm');
    this.adminService.registerExchangeStudent(payload, (err, res) => {
      this.ui.loader.hide('register-student-list => submitStudentRegisterForm');
      if (err) {
        if (Object.keys(err).length) {
          swal('Warning!', err[Object.keys(err)[0]], 'warning');
        }
      } else {
        swal('Success!', 'Student created successfully', 'success');
        this.studentRegisterModalCloseBtn.nativeElement.click();
        this.registered.emit({
          ...this.newStudent,
          id: res.data.id
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/programme/programme-details/modals/register-student-modal/register-student-modal.component.ts